module.exports = __webpack_public_path__ + "img/guideline_our_standards.ad8ae7eb.jpeg";